module.exports = __webpack_public_path__ + "static/media/roll.0cfc393c.png";